export default "__VITE_ASSET__D56y2aCK__"